module.exports = __webpack_public_path__ + "img/hgi-logo-truong-chinh-tri.f58cd72c.png";